import { api } from "../../api/client";

export type PopularityScore = "very_low" | "low" | "medium" | "high" | "very_high";
export type SubjectType = "internal" | "external" | "person";
export type ScopeLevel = "constituency" | "ward" | "branch";
export type Classification = "unclassified" | "restricted" | "secret";

export interface PopularityReport {
  id: string;
  reporterUid: string;
  subjectType: SubjectType;
  subjectUid: string | null;
  subjectPersonId?: string | null;
  subjectName: string | null;
  subjectContext: string;
  scopeLevel: ScopeLevel;
  scopeId: string;
  branchId: string | null;
  wardId: string | null;
  constituencyId: string | null;
  score: PopularityScore;
  observations: string;
  classification: Classification;
  createdAt: string;
}

interface List<T> { items: T[]; }

export interface PopularityCreate {
  subjectType: SubjectType;
  subjectUid?: string;
  subjectPersonId?: string;
  subjectName?: string;
  subjectContext?: string;
  scopeLevel: ScopeLevel;
  scopeId: string;
  pollingStationId?: string;
  score: PopularityScore;
  observations: string;
  classification?: Classification;
  sourcesCount?: number;
  confidenceScore?: number;
}

export const PopularityApi = {
  list: (filters?: {
    score?: PopularityScore;
    scopeLevel?: ScopeLevel;
    scopeId?: string;
    subjectType?: SubjectType;
  }) => {
    const qs = new URLSearchParams();
    if (filters?.score) qs.set("score", filters.score);
    if (filters?.scopeLevel) qs.set("scopeLevel", filters.scopeLevel);
    if (filters?.scopeId) qs.set("scopeId", filters.scopeId);
    if (filters?.subjectType) qs.set("subjectType", filters.subjectType);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return api<List<PopularityReport>>(`/popularity-reports${suffix}`);
  },
  get: (id: string) => api<PopularityReport>(`/popularity-reports/${id}`),
  create: (body: PopularityCreate) =>
    api<PopularityReport>("/popularity-reports", { method: "POST", body: JSON.stringify(body) }),
};
